import { render, staticRenderFns } from "./spdfh5.vue?vue&type=template&id=54cb3071&scoped=true&"
import script from "./spdfh5.vue?vue&type=script&lang=js&"
export * from "./spdfh5.vue?vue&type=script&lang=js&"
import style0 from "./spdfh5.vue?vue&type=style&index=0&id=54cb3071&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cb3071",
  null
  
)

export default component.exports